{
    "name": "Cantaloupe",
    "binomial_name": "Cucumis melo var. cantalupo",
    "common_names": [
        "Cantaloupe",
        "Muskmelon"
    ],
    "description": "Cantaloupes are round melons that grow on vines and have sweet, firm, juicy, orange flesh. The rind is light-grey and reticulated (or covered in a \"net-like\" pattern).",
    "sun_requirements": "Full Sun",
    "sowing_method": "Sow 2-3 seeds per peat pot indoors and transplant peat pots directly into soil when soil is warm. Thin to 1 seedling.",
    "spread": 150,
    "row_spacing": 45,
    "height": 40,
    "growing_degree_days": 0,
    "companions": [],
    "image": "/crops/images/cantaloupe.jpg",
    "icon": "/crops/icons/cantaloupe.avif"
}